<template>
  <div>
    <Modal v-model="show" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">分享链接</h3>
      <div>
        <div style="color: rgb(150,150,150)">温馨提示：请输入少于500个字符！！</div>
        <Input type="textarea" :rows="4" :maxlength="500" v-model="shareUrl"/>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {houseTypeConfig} from "api/houseTypeConfig";

  export default {
    name: "Kangfang",
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      },
      oldShareUrl:{
         type:String,
        default:''
      }

    },
    watch:{
      n(){
        this.show=true
      },
      oldShareUrl(val) {
        this.shareUrl = val
      }
    },
    data(){
      return {
        show:false,
        shareUrl:'',
        loading:true,
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        let data = {
          fid: this.fid,
          shareUrl: this.shareUrl
        };
        houseTypeConfig(data).then(res=>{
          this.$Message.success('分享链接配置成功');
          this.changeLoading();
          this.$emit('refresh');
          this.show = false
        })
       
      },

    },

  }
</script>

<style scoped>

</style>
